import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

/**
 * /dashboard and /profile: your own page on that tab — user-agnostic links
 * for places like release notes. Signed out, there's no page of yours to show,
 * so it's home.
 */
export default function ProfileRedirect({ tab = "dashboard" }) {
  const { user, isAuthLoading } = useAuth();

  // Until auth resolves, a signed-in user looks signed out
  if (isAuthLoading) return null;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // The dashboard is Profile's default tab, so it needs no segment
  const suffix = tab === "profile" ? "/profile" : "";
  return <Navigate to={`/u/${user.username}${suffix}`} replace />;
}
